import { createI18n } from 'vue-i18n';

export default createI18n({
  legacy: false, // use the new composition API
  missingWarn: false,
  fallbackWarn: false,
  fallbackLocale: ['en', 'fr'],
});
